import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { EmployeeSkill, EmployeeSkillCreate, EmployeeSkillFilter } from '../data/employeeSkill';

export function createEmployeeSkillService(client: AxiosInstance) {
  return createCrudService<EmployeeSkill, EmployeeSkillCreate, EmployeeSkillFilter>(
    client,
    '/hrm/EmployeeSkill',
    'id',
  );
}

export type EmployeeSkillService = CrudService<EmployeeSkill, EmployeeSkillCreate, EmployeeSkillFilter>;
